<div>
    <v-dialog v-model="valueSync" max-width="60%">
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" color="primary">
                {{ buttonSignature }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ header }}</span>
            </v-card-title>
            <v-card-text>
                <HtmlEditor
                    v-model:content="content"
                    identifier="MainContent" />
                <HtmlEditor
                    v-model:content="signature"
                    identifier="Signature" />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="saveContent">
                    Save
                </v-btn>
                <v-btn color="red-darken-1" variant="text" @click="close">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>